import AbstractIceContentController from '../../abstract/ice-content/controller';

const HELPERS = window.App.Utils.Helpers;

class Controller extends AbstractIceContentController {
    constructor(widget) {
        super(widget);
        this.init(widget);
        this.showModal();
    }

    init(widget) {

        const domNoDisplay = 'no-display';
        const messageWrapper = 'message-wrapper';
        const subscribeData = widget.getPreference('subscribe');
        const notHttpResponse = sessionStorage.getItem(subscribeData);

        if (!App.Portal.isInDesignMode()) {

            this.clearSessionStorage();
            const result = JSON.parse(notHttpResponse);

            if (result && result.withIcon) {
                document.getElementById('widget-errormap').classList.remove('simple');
            }

            if (!result.isMaintenance) {
                //Replace if no mobile and no address
                const replacePhraseForNoMobile = widget.getPreference('replacePhraseForNoMobile');
                const replacementPhraseforNoMobile = widget.getPreference('replacementPhraseforNoMobile');
                document.getElementById(messageWrapper).classList.remove(domNoDisplay);
                $('#staticIcon').css('display', 'block');
                $('#errorTitle').html(result.status);
                $('#errorContent').html(result.message.replace(replacePhraseForNoMobile, replacementPhraseforNoMobile));
                //Replace if other messages
                const replacePhraseWhenError = widget.getPreference('replacePhraseWhenError');
                const replacementPhraseWhenError = widget.getPreference('replacementPhraseWhenError');
                const str = document.getElementById(messageWrapper).innerHTML;
                const res = str.replace(replacePhraseWhenError, replacementPhraseWhenError);
                document.getElementById(messageWrapper).innerHTML = res;
            } else {
                document.body.classList.add('maintenance');
                document.body.innerHTML = document.getElementById('maintenance').outerHTML;
            }
        }

    }

    showModal() {

        const modalData = {
            content: '',
            isIce: true,
            size: 'fullscreen',
            disableScroll: true,
            showCloseIcon: true,
            showButton: true,
        };

        const btnShowModal = document.getElementsByClassName('widgetContainerTemplate__action-link')[0];

        $(btnShowModal).click(function () {
            App.PubSub.publish('faqModal', modalData);
            const showLess = document.getElementsByClassName(
                'widgetContainerTemplate__action-link'
            )[1];
            const showMore = document.getElementsByClassName('show-link')[0];
            const container = document.getElementsByClassName('widget-faq-modal__container')[0];
            const content = document.getElementById('faq-modal-content');
            const faq = document.getElementsByClassName('widget-faq')[3];
            $(container).css('max-height', '1400px');
            $(content).css('transform', 'translateY(-30%)');
            $(showLess).css('display', 'none');
            $(showMore).css('display', 'block');
            $(faq).css('display', 'none');
        });

    }

    clearSessionStorage() {

        HELPERS.removeFromStorage();
        HELPERS.deleteCookie('BBXSRF');
        sessionStorage.removeItem('integrationData');
        sessionStorage.removeItem('dupApp');
        sessionStorage.removeItem("confirmationDetails");
        sessionStorage.removeItem('creditCardCode');

    }

}
export default Controller;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-errormap/scripts/controller.js